import { FilterWrapper } from "./filterWrapper";

interface TextFilterProps {
  column: any;
  placeholder: string;
}

export const TextFilter: React.FC<TextFilterProps> = ({
  column,
  placeholder,
}) => {
  const filterValue = column.getFilterValue() as string | undefined;

  return (
    <FilterWrapper
      filterValue={filterValue}
      onClear={() => column.setFilterValue(undefined)}
      className="w-3/4"
    >
      <input
        type="text"
        value={filterValue ?? ''}
        onChange={(e) => column.setFilterValue(e.target.value)}
        className="w-full border-2 border-black rounded px-2 py-1 text-sm font-normal"
        placeholder={placeholder}
      />
    </FilterWrapper>
  );
};
